import React from 'react';
import './ServicesSection.css';
import {
  FaLaptopCode,
  FaChartLine,
  FaTools,
  FaProjectDiagram,
  FaRobot,
  FaLightbulb,
} from 'react-icons/fa';

const ServicesSection = () => {
  const services = [
    {
      icon: <FaLaptopCode />,
      title: 'Desarrollo Web',
      text: 'Creamos aplicaciones digitales personalizadas para tu negocio.',
      delay: '0.1s',
    },
    {
      icon: <FaChartLine />,
      title: 'Consultoría Estratégica',
      text: 'Estrategias para optimizar procesos y maximizar resultados.',
      delay: '0.3s',
    },
    {
      icon: <FaTools />,
      title: 'Sistemas Personalizados',
      text: 'Diseñamos soluciones tecnológicas a medida para tu empresa.',
      delay: '0.5s',
    },
    {
      icon: <FaProjectDiagram />,
      title: 'Optimización de Procesos',
      text: 'Mejoramos tus flujos de trabajo para maximizar la eficiencia.',
      delay: '0.7s',
    },
    {
      icon: <FaRobot />,
      title: 'Automatización Empresarial',
      text: 'Automatizamos tareas clave para ahorrar tiempo y recursos.',
      delay: '0.9s',
    },
    {
      icon: <FaLightbulb />,
      title: 'Asesoría en Innovación',
      text: 'Estrategias modernas para la transformación digital de tu negocio.',
      delay: '1.1s',
    },
  ];

  return (
    <section id="services-section" className="services-section">
      <div className="container">
        <h2 className="services-title">¿Qué ofrecemos en SBK?</h2>
        <p className="services-intro">
          Nuestro equipo de expertos está listo para transformar tu negocio con innovación y tecnología.
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div
              className="service-item"
              style={{ animationDelay: service.delay }}
              key={index}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-text">{service.text}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServicesSection;
